import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: string;
    labelUndo: string;
    labelGoToShare: string;
    labelCreateNewShare: string;
    labelCancel: string;
    restrictedAssetsLimitReached: string;
    added: ({ addedCount, name }: {
        addedCount: number;
        name: string;
    }) => string | React.ReactNode;
    noneAdded: ({ count, name }: {
        count: number;
        name: string;
    }) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** A message to display within a toast when an error occurs during the attempted update of a share link */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.error?c=2pffx1f7yo5fu", defaultMessage: "There was a problem updating your Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the undo button */
            labelUndo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.labelUndo?c=n4og3f213zda", defaultMessage: "Undo" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the go to share button */
            labelGoToShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.labelGoToShare?c=2fjtzscn0n8uc", defaultMessage: "Go to Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the create new share button */
            labelCreateNewShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.labelCreateNewShare?c=3a57a4kro2am1", defaultMessage: "Create new Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the cancel button */
            labelCancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.labelCancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when the restricted assets limit is reached */
            restrictedAssetsLimitReached: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.restrictedAssetsLimitReached?c=1r094wjiayirp", defaultMessage: "Can\u2019t share items \u2013 this share has reached the 250 restricted item limit." }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when assets are added to a share */
            added: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ addedCount, name }: {
                        addedCount: number;
                        name: string;
                    }) => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.added?c=lm1qk62o3tbb", defaultMessage: "{addedCount, plural, one {1 new asset added to \"{name}\"} other {{addedCount} new assets added to \"{name}\"}}" }, { addedCount: addedCount, name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when no assets are added to a share */
            noneAdded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count, name }: {
                        count: number;
                        name: string;
                    }) => __intl__.intl().formatMessage({ id: "useAddAssetsToShare.noneAdded?c=2zp2xybt6d1w4", defaultMessage: "{count, plural, one {Asset already exists in \"{name}\"} other {Assets already exist in \"{name}\"}}" }, { count: count, name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
